import HighlightAltIcon from '@mui/icons-material/HighlightAlt'
import { IconButton, IconButtonProps } from '@mui/material'

const SelectIconButton = (props: IconButtonProps) => {
  return (
    <IconButton {...props}>
      <HighlightAltIcon />
    </IconButton>
  )
}

export default SelectIconButton
